export default "__VITE_ASSET__BVfyQhvN__"